export const videoConfigs = [
  {
    // Landing screen
    src: '/assets/intro.mp4',
    type: 'background',
    route: '/',
    loop: false
  },
  {
    // Passive screen
    src: '/assets/loop.mp4',
    type: 'background',
    route: '/space',
    loop: true
  },
  {
    // Create star screen
    src: '/assets/passive_create.mp4',
    type: 'background',
    route: '/create-star',
    loop: true
  },
  {
    // Find star screen
    src: '/assets/passive_create.mp4',
    type: 'background',
    route: '/find-star',
    loop: true
  },
  {
    // View star screen
    src: '/assets/passive_view.mp4',
    type: 'background',
    route: '/view-star/*',
    loop: true
  },
  {
    // confirmation screen
    src: '/assets/passive_create.mp4',
    type: 'background',
    route: '/confirmation/*',
    loop: true
  },
  {
    // About screen
    src: '/assets/passive_about.mp4',
    type: 'background',
    route: '/about',
    loop: true
  },
  {
    // Support screen
    src: '/assets/passive_about.mp4',
    type: 'background',
    route: '/support',
    loop: true
  },
  {
    // Messages screen
    src: '/assets/passive_view.mp4',
    type: 'background',
    route: '/messages',
    loop: true
  }
];

export const videoTransitions = [
  {
    // Transition from find star screen to view star screen
    from: '/find-star',
    to: '/view-star/*',
    src: '/assets/transitions/sml/create_view.mp4',
    duration: 4000
  },
  {
    // Transition from create star screen to view star screen
    from: '/create-star',
    to: '/view-star/*',
    src: '/assets/transitions/sml/create_view.mp4',
    duration: 4000
  },
  {
    // Transition from confirmation screen to view star screen
    from: '/confirmation/*',
    to: '/view-star/*',
    src: '/assets/transitions/sml/create_view.mp4',
    duration: 4000
  }
]; 